import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { MenuComponent } from './components/menu/menu.component';
import { ButtonComponent } from './components/button/button.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { MenuDrawerComponent } from './components/menu-drawer/menu-drawer.component';
import { AccessibilityStatementModalComponent } from './components/accessibility-statment-modal/accessibility-statement-modal.component';
import { FeedbackModalComponent } from 'src/app/components/feedback-modal/feedback-modal.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GlobalService } from './services/global.service';
import { allowKeyboardFocus } from './directives/allowKeyboardFocus';
import { StorageService } from './services/storage.service';
import { ApiClientService } from './services/apiClient.service';
import { RemoteDataService } from './services/remoteData.service';

@NgModule({
    declarations: [
        AppComponent,
        MenuComponent,
        ButtonComponent,
        CheckboxComponent,
        MenuDrawerComponent,
        AccessibilityStatementModalComponent,
        FeedbackModalComponent,
        allowKeyboardFocus
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [GlobalService, StorageService, ApiClientService,RemoteDataService],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}